export const CURRENT_TERMS_VERSION = "2026-07-16";
